
import { defineComponent, ref, onMounted, computed } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import GenerateReportIcon from "../components/IconRegenerate.vue";

import { FormatMethods } from "@/helpers/data-format";
import { usePagination } from "@/helpers/pagination";
import { IBulkDelete } from "@/interfaces/iPageModel";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { TranslationService } from "@/core/services/TranslationService";

import {
  DocumentsTableFilters,
  DocumentsTableHeaders,
  DocumentTableBulkDelete,
} from "../siteDataTableOptions";
import { IDocuments, IFile } from "@/interfaces/iDocument";
import { DocumentApi } from "@/services/api/Document.service";
import AudioModal from "@/components/modals/forms/AudioModal.vue";

export default defineComponent({
  name: "document-index",
  components: {
    Datatable,
    GenerateReportIcon,
    // eslint-disable-next-line vue/no-unused-components
    "vz-audio-modal": AudioModal,
  },
  setup() {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const { page, total, rowsPerPage } = usePagination();
    const loading = ref(false);
    const showAudioDialog = ref<any>(false);
    const defaultFilter = ref({ scheduleStatus: "COMPLETED" });
    const showSearch = true;
    const tableData = ref<IDocuments[]>([]);
    const bulkDelete = ref<IBulkDelete>(DocumentTableBulkDelete());
    const tableHeader = ref(DocumentsTableHeaders());
    const tableFilter = ref(DocumentsTableFilters());
    const localPreference = ref({});
    let audioId = ref<any>([]);
    const setAudioData = async (data: any) => {
      showAudioDialog.value = true;
      audioId.value = data;
    };
    const format = computed(() => {
      return FormatMethods;
    });
    onMounted(() => {
      setCurrentPageBreadcrumbs(t("common.documents"), ["Home", "Tasks"]);
      loading.value = true;
      // await queryUpdate({
      //   ...localPreference.value,
      //   ...defaultFilter.value,
      //   sort: "startDate,desc",
      // });
    });
    const queryUpdate = async (params?: any) => {
      try {
        loading.value = true;
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "startDate,desc",
            startDate: params?.startDate === null ? [] : params?.startDate,
          };
        }
        localPreference.value = { ...params };
        const data = await DocumentApi.getInstance().getDocumentsList({
          ...params,
        });
        tableData.value = [...data.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };
    const refreshList = () => {
      queryUpdate({ ...localPreference.value });
    };
    const downloadFile = async (files: IFile[]) => {
      try {
        const file = files?.find((f) => f.key);
        if (!file) {
          return;
        }
        loading.value = true;
        await DocumentApi.getInstance().downloadFile(
          `${file.key}`,
          `${file.key}.pdf`
        );
      } catch (e) {
        console.log(e);
      } finally {
        loading.value = false;
      }
    };
    const generatePDF = async (document: IDocuments) => {
      try {
        loading.value = true;
        await DocumentApi.getInstance().generatePDF(document.webId);
        refreshList();
      } catch (e) {
        console.log(e);
      } finally {
        loading.value = false;
      }
    };
    return {
      setAudioData,
      bulkDelete,
      format,
      tableData,
      tableHeader,
      tableFilter,
      showSearch,
      page,
      total,
      rowsPerPage,
      defaultFilter,
      loading,
      queryUpdate,
      t,
      refreshList,
      downloadFile,
      generatePDF,
      audioId,
      showAudioDialog,
    };
  },
});
